<template>
  <div class="contents-intro">
    <p class="ttl">INTRODUCTION</p>
    <p class="txt01"><slot></slot></p>
    <div class="contents-box">
      <div class="card">
        <div class="card-img">
          <img :src="image_src(iconLeft)" class="img-fluid icon" alt="" />
        </div>
        <div class="card-body">
          <p class="card-title _mb-sm-0">{{ nameLeft }}</p>
          <!--<p class="card-text">{{ageLeft}}</p>-->
        </div>
      </div>
      <div class="img-box">
        <span class="txt02">{{ txtRelation }}</span>
      </div>
      <div class="card">
        <div class="card-img">
          <img :src="image_src(iconRight)" class="img-fluid icon" alt="" />
        </div>
        <div class="card-body">
          <p class="card-title _mb-sm-0">{{ nameRight }}</p>
          <!--<p class="card-text">{{ageRight}}</p>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentsIntro",
  props: {
    iconLeft: { type: String, default: "" },
    nameLeft: { type: String, default: "" },
    ageLeft: { type: String, default: "" },
    iconRight: { type: String, default: "" },
    nameRight: { type: String, default: "" },
    ageRight: { type: String, default: "" },
    txtRelation: { type: String, default: "" },
  },
  methods: {
    image_src(src) {
      return require("@/assets/images/sv/" + src);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.contents-intro {
  &.-blue {
    > .ttl {
      color: $blue;
    }
  }
  &.-green {
    > .ttl {
      color: $green;
    }
  }
  &.-orange {
    > .ttl {
      color: $orange;
    }
  }
  padding-top: 30px;
  padding-bottom: 40px;
  @include mq-up(md) {
    border-radius: 10px;
    margin-bottom: 120px;
    border: 1px solid $secondary;
  }
  @include mq-down(md) {
    padding-top: 75px;
  }
  .ttl {
    font-weight: bold;
    font-size: 24px;
    text-align: center;
    margin-bottom: 15px;
    @include mq-up(md) {
      margin-bottom: 20px;
    }
  }
  .txt01 {
    margin-bottom: 30px;
    @include mq-up(md) {
      text-align: center;
    }
  }
  .contents-box {
    max-width: 760px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .card {
      display: flex;
      align-items: center;
      @include mq-down(md) {
        flex-wrap: wrap;
      }
      .card-img {
        @include mq-down(md) {
          max-width: 60px;
          margin: 0 auto 10px;
        }
        .icon {
          @include mq-up(md) {
            width: 120px;
          }
        }
      }
      .card-body {
        @include mq-up(md) {
          margin-left: 15px;
        }
        @include mq-down(md) {
          text-align: center;
          width: 100%;
        }
        .card-title {
          @include mq-down(md) {
            line-height: 14px;
          }
        }
        .card-text {
          color: #666;
          @include mq-down(md) {
            line-height: 14px;
            font-size: 10px;
          }
        }
      }
    }
    .img-box {
      width: 118px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-image: url("@/assets/images/sv/common/bgcenter_sp.png");
      background-position: center center;
      background-repeat: no-repeat;
      @include mq-up(md) {
        width: 180px;
        height: 52px;
        background-image: url("@/assets/images/sv/common/bgcenter.png");
      }
      .txt02 {
        font-size: 10px;
        @include mq-up(md) {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
